import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propShape, propStr, } from '../../../helpers/custom-prop-types';
const InputError = (props) => {
    const { className, error, meta, metas } = props;
    const targetError = useMemo(() => {
        if (error) {
            return error;
        }
        const resultMeta = [...metas, meta].find((checkMeta) => checkMeta &&
            checkMeta.touched &&
            (checkMeta.error ||
                (checkMeta.submitError && !checkMeta.dirtySinceLastSubmit)));
        return resultMeta ? resultMeta.error || resultMeta.submitError : null;
    }, [meta, metas, error]);
    return (targetError && (_jsx("div", Object.assign({ className: className }, { children: _jsx("span", Object.assign({ className: 'font-alert' }, { children: targetError })) }))));
};
InputError.propTypes = {
    className: propStr(),
    error: propStr(),
    meta: propShape(),
    metas: propArrayShape(),
};
InputError.defaultProps = {
    className: '',
    error: '',
    meta: {},
    metas: [],
};
export default InputError;
